import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/components/EmptyState';

export const RatingsEmptyCard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[220px] flex-col rounded-xl bg-popover py-8 shadow-card">
      <EmptyState
        label={t('overview.empty.title')}
        description={t('overview.empty.description')}
      />
    </div>
  );
};
